import { useMutation } from "@tanstack/react-query";
import {
  type PartyDto,
  type PartyType,
  type Region,
  getPartiesSearchAres,
} from "Infrastructure/Api/Api";
import {
  getApiErrorStatus,
  processResponseWithApiProblemDetails,
} from "Infrastructure/Api/ApiUtils";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  onSuccess?: (aresData: PartyDto | null) => void;
  onError?: () => void;
};

export const usePartySearchAresMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      async ({
        query,
        partyType,
        region,
      }: {
        query: string;
        partyType?: PartyType;
        region: Region;
      }) =>
        // An unknown identifier is a 404 the register returns for typos and new companies. The
        // response is thrown as-is so the error reporter keeps it as a breadcrumb instead of a
        // Sentry event; the toast below tells the user what happened.
        getPartiesSearchAres(query, partyType, region),
    ),
    onSuccess,
    onError:
      onError ||
      ((error) =>
        toast.error(
          t(
            getApiErrorStatus(error) === 404
              ? Resources.Hooks.Ares.SubjectNotFound
              : Resources.Hooks.Ares.Error,
          ),
        )),
  });
};
